<ai-floating-panel #floatingPanel [style.--ring-color]="computedRingColor()">
  <div class="talk-panel-content">
    <div class="assistant-avatar-container">
      <div class="avatar-wrapper" [class.speaking]="isSpeaking()" [class.connecting]="isConnecting()">
        @if (config.assistantAvatarUrl) {
          <glxy-avatar class="large-avatar" [src]="config.assistantAvatarUrl" [width]="80"></glxy-avatar>
        } @else {
          <glxy-avatar class="large-avatar" [svgIcon]="config.assistantIcon" [width]="80"></glxy-avatar>
        }
      </div>
    </div>

    <div class="talk-content">
      <h3 class="assistant-name">{{ config.assistantName }}</h3>
      @if (config.jobTitle) {
        <p class="job-title">{{ config.jobTitle | translate }}</p>
      }

      @if (isConnecting()) {
        <p class="status-text connecting">{{ 'AI_ASSISTANT.WORKFORCE.WEBRTC.CONNECTING' | translate }}</p>
      } @else if (isConnected()) {
        @if (isMuted()) {
          <p class="status-text muted">{{ 'AI_ASSISTANT.WORKFORCE.WEBRTC.MUTED' | translate }}</p>
        } @else {
          <p class="status-text connected">{{ 'AI_ASSISTANT.WORKFORCE.WEBRTC.CONNECTED' | translate }}</p>
        }
      } @else if (isCallEnded()) {
        <p class="status-text">{{ 'AI_ASSISTANT.WORKFORCE.WEBRTC.CALL_ENDED' | translate }}</p>
      } @else if (hasError()) {
        <p class="status-text error">{{ errorMessage() }}</p>
      }
    </div>

    @if (hasError()) {
      <div class="call-controls">
        <button mat-stroked-button color="primary" (click)="startCall()">
          <mat-icon>refresh</mat-icon>
          {{ 'AI_ASSISTANT.WORKFORCE.WEBRTC.RETRY' | translate }}
        </button>
      </div>
    }

    @if (isConnected()) {
      <div class="action-buttons">
        <button
          mat-icon-button
          (click)="toggleMute()"
          [attr.aria-label]="'AI_ASSISTANT.WORKFORCE.WEBRTC.TOGGLE_MICROPHONE' | translate"
          [class.caller-speaking]="isCallerSpeaking()"
        >
          <mat-icon>{{ isMuted() ? 'mic_off' : 'mic' }}</mat-icon>
        </button>
      </div>
    }
  </div>
</ai-floating-panel>
